/**
 * @generated SignedSource<<897e6d8a257175e92798f978aef133fa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BookmarkButtonRemoveMutation$variables = {
  id: string;
};
export type BookmarkButtonRemoveMutation$data = {
  readonly removeBookmark: boolean;
};
export type BookmarkButtonRemoveMutation = {
  response: BookmarkButtonRemoveMutation$data;
  variables: BookmarkButtonRemoveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "kind": "ScalarField",
    "name": "removeBookmark",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BookmarkButtonRemoveMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BookmarkButtonRemoveMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "bf51e036e42024f89842bff2114ab2d7",
    "id": null,
    "metadata": {},
    "name": "BookmarkButtonRemoveMutation",
    "operationKind": "mutation",
    "text": "mutation BookmarkButtonRemoveMutation(\n  $id: ID!\n) {\n  removeBookmark(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "80bce26eb4824fd39186d8be3d15e32a";

export default node;
